import apiClient from './client';

export interface ClosePlan {
  id: number;
  lead_id: number;
  pain_points?: string;
  decision_criteria?: string;
  objections?: string;
  next_steps?: string;
  created_by?: number;
  created_at: string;
  updated_at: string;
}

export const closePlansApi = {
  getByLeadId: async (leadId: number): Promise<ClosePlan | null> => {
    try {
      const response = await apiClient.get<{ success: boolean; data: ClosePlan }>(`/close-plans/lead/${leadId}`);
      return response.data.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },
  getAllByLeadId: async (leadId: number): Promise<ClosePlan[]> => {
    const response = await apiClient.get<{ success: boolean; data: ClosePlan[] }>(`/close-plans/lead/${leadId}/history`);
    return response.data.data;
  },
  getById: async (id: number): Promise<ClosePlan> => {
    const response = await apiClient.get<{ success: boolean; data: ClosePlan }>(`/close-plans/${id}`);
    return response.data.data;
  },
  create: async (closePlan: Partial<ClosePlan>): Promise<ClosePlan> => {
    const response = await apiClient.post<{ success: boolean; data: ClosePlan }>('/close-plans', closePlan);
    return response.data.data;
  },
  update: async (id: number, closePlan: Partial<ClosePlan>): Promise<ClosePlan> => {
    const response = await apiClient.patch<{ success: boolean; data: ClosePlan }>(`/close-plans/${id}`, closePlan);
    return response.data.data;
  },
  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/close-plans/${id}`);
  },
};
